/* eslint-disable react/prop-types */
import React, { useContext, useMemo, useState } from "react";
import NavHeader, { NavLink } from "./NavHeader";
import { BsCalendarWeek, BsBookmarkCheckFill } from "react-icons/bs";
import { RiLogoutCircleRLine } from "react-icons/ri";
import { FaUserClock, FaUsers } from "react-icons/fa";
import { IoChatboxEllipsesOutline } from "react-icons/io5";
import { RiUserSettingsLine } from "react-icons/ri";
import { AiOutlineNotification } from "react-icons/ai";
import { MdSwitchAccount, MdWorkHistory } from "react-icons/md";
import { IoIosHelpCircleOutline } from "react-icons/io";
import useLogout from "./useLogout";
import "../../sass/zeplin/ClinicHeader.scss";
import GenericModal from "./GenericModal";
import { ICONS } from "./constants/swal.constants";
import { UserContext } from "components/context/UserContext";
import { IoReturnUpBackOutline } from "react-icons/io5";
import { useHistory, useLocation } from "react-router-dom";
import { restoreDelegateUser } from "services/companyServices";
export const CalendarIcon = ({ stroke }) => {
  return <BsCalendarWeek fill={stroke} size={35} />;
};

export const AppointmentsIcon = ({ stroke }) => {
  return <FaUserClock fill={stroke} size={35} />;
};

export const BookedIcon = ({ stroke }) => {
  return <BsBookmarkCheckFill fill={stroke} size={35} />;
};

export const AccountsIcon = ({ stroke }) => {
  return <MdSwitchAccount fill={stroke} size={40} />;
};

export const RepsIcon = ({ stroke }) => {
  return <FaUsers fill={stroke} size={40} />;
};

export const ProfileIcon = ({ stroke }) => {
  return <RiUserSettingsLine fill={stroke} size={35} />;
};

export const History = ({ stroke }) => {
  return <MdWorkHistory fill={stroke} size={35} />;
};

export const AnnouncementsIcon = ({ stroke }) => {
  return <AiOutlineNotification fill={stroke} size={35} />;
};

export const LogoutIcon = () => {
  return <RiLogoutCircleRLine fill="#224984" size={35} />;
};
export const ReturnIcon = () => {
  return <IoReturnUpBackOutline fill="#224984" size={35} />;
};
export const ChatIcon = () => {
  return <IoChatboxEllipsesOutline fill="#224984" size={35} />;
};
export const HelpCenterIcon = () => {
  return <IoIosHelpCircleOutline fill="#224984" size={35} />;
};
// export const TemplateIcon = () => {
//   return <GrTemplate fill="#224984" size={35} />;
// };
const links = [
  { pathname: "/client/calendar", Img: CalendarIcon, name: "Calendar" },
  {
    pathname: "/client/template",
    Img: CalendarIcon,
    name: "Recurring",
  },
  { pathname: "/appointments", Img: AppointmentsIcon, name: "Appointments" },
  { pathname: "/client/reps", Img: RepsIcon, name: "Reps" },
  { pathname: "/profile", Img: ProfileIcon, name: "Profile" },
  { pathname: "/client/user-activity", Img: History, name: "Activity" },
  { pathname: "/chat", Img: ChatIcon, name: "Chat" },
  { pathname: "/help-center", Img: HelpCenterIcon, name: "Help Center" },
];
const delegateUserLinks = [
  { pathname: "/delegate/calendar", Img: CalendarIcon, name: "Calendar" },
];
const delegateUserRoutes = ["/delegate/calendar", "/impersonation-options"];
const ClinicHeader = () => {
  const history = useHistory();
  const location = useLocation();
  const { state, dispatch } = useContext(UserContext);

  const [genericModalData, setGenericModalData] = useState({
    show: false,
  });
  const showLogoutSuccess = () => {
    setGenericModalData({
      show: true,
      title: "Goodbye",
      subtext: "See you next time!",
      icon: ICONS.checkMark,
    });
  };
  const showLogoutError = () => {
    setGenericModalData({
      show: true,
      title: "Oops!",
      subtext: "Some error occurred",
      icon: ICONS.error,
    });
  };
  const hideModal = () => {
    setGenericModalData((prevState) => ({ ...prevState, show: false }));
  };
  const handleReturnFromImpersonation = async () => {
    try {
      // 1. Restore delegate cookie on backend
      const res = await restoreDelegateUser();
      if (!res.isSuccessful) {
        // fallback: maybe just send them to /login
        history.push("/login");
        return;
      }
      dispatch({
        type: "SET_IMPERSONATING",
        payload: { isImpersonating: false },
      });
      // 3. Go back to impersonation options (or wherever)
      history.push("/impersonation-options");
    } catch (e) {
      console.log({ e });

      history.push("/login");
    }
  };

  const linksToUse = useMemo(() => {
    if (
      delegateUserRoutes.includes(location.pathname) &&
      state?.currentUser?.roleId === 8
    ) {
      return delegateUserLinks;
    }
    return links;
  }, [location.pathname, state?.currentUser?.roleId]);

  const logOut = useLogout(
    "/login",
    showLogoutSuccess,
    showLogoutError,
    hideModal,
  );

  return (
    <>
      {genericModalData.show && (
        <GenericModal
          show={genericModalData.show}
          onHide={hideModal}
          title={genericModalData?.title || ""}
          subtext={genericModalData?.subtext || ""}
          icon={genericModalData?.icon || undefined}
          hideBtn
        />
      )}
      <NavHeader
        links={linksToUse}
        renderLinks={() => {
          return (
            <>
              {state?.currentUser?.roleId === 8 ? (
                <NavLink
                  Img={ReturnIcon}
                  onClick={handleReturnFromImpersonation}
                  name="Return"
                  data-cy="return-btn"
                />
              ) : (
                <NavLink
                  Img={LogoutIcon}
                  onClick={() => {
                    return logOut();
                  }}
                  name="Log out"
                  data-cy="logout-btn"
                />
              )}
            </>
          );
        }}
      />
    </>
  );
};

export default ClinicHeader;
